import { Modal } from 'bootstrap';
import Selectr from "mobius1-selectr"
import {DataTable} from "simple-datatables";

import {api} from './apiService.js';
import {handleError} from './handleError.js';
import {formatCreditTerm, formatCurrency, toPersianDigits, translateContactType} from "./utils";

import modalHtml from '../modules/contact-form-modal.html';
import {showAlert} from "./alert";

const contactsAlertId = 'acc-contacts-alert';
const settingsAlertId = 'acc-settings-alert';

let datatable, detailCodeSelectr;
let isResettingForm = false;

// Contacts:

function gbs(num) {
    if (num < 0) return { color: 'danger', text: 'بستانکار' };
    if (num > 0) return { color: 'success', text: 'بدهکار' };
    return { color: 'secondary', text: 'تسویه' };
}

function generateDetailsSkeletonHtml() {
    return `
        <div class="placeholder-glow mt-2 mb-2 border-top border-bottom pt-2 pb-2">
            <div class="row align-items-center mb-2"><div class="col-5 text-end"><span class="placeholder col-10"></span></div><div class="col-4 text-center"><span class="placeholder col-8"></span></div><div class="col-3 text-start"><span class="placeholder col-8"></span></div></div>
            <div class="row align-items-center mb-2"><div class="col-5 text-end"><span class="placeholder col-10"></span></div><div class="col-4 text-center"><span class="placeholder col-8"></span></div><div class="col-3 text-start"><span class="placeholder col-8"></span></div></div>
            <div class="row align-items-center mb-2"><div class="col-5 text-end"><span class="placeholder col-10"></span></div><div class="col-4 text-center"><span class="placeholder col-8"></span></div><div class="col-3 text-start"><span class="placeholder col-8"></span></div></div>
            <div class="row align-items-center mb-2"><div class="col-5 text-end"><span class="placeholder col-10"></span></div><div class="col-4 text-center"><span class="placeholder col-8"></span></div><div class="col-3 text-start"><span class="placeholder col-8"></span></div></div>
            <div class="row align-items-center"><div class="col-5 text-end"><span class="placeholder col-10"></span></div><div class="col-4 text-center"><span class="placeholder col-8"></span></div><div class="col-3 text-start"><span class="placeholder col-8"></span></div></div>
        </div>
    `;
}

function generateContactCardHtml(contact) {
    const balance = contact.cached_total_balance;
    const contactType = translateContactType(contact.contact_type);

    return `
    <div class="col-lg-4">
        <div class="card border-start border-2 border-${gbs(balance).color}" id="contact-card-${contact.id}">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="card-title m-0">${contact.name}</h5>
                    <span class="badge rounded-pill bg-secondary-subtle text-secondary">${contactType}</span>
                </div>
                <div class="d-flex justify-content-center text-center m-0">
                    <h2 class="display-6 fw-bold m-0">${formatCurrency(balance)} <small class="text-muted fs-5">ریال</small></h2>
                </div>
                <div class="collapse" id="details-${contact.id}"></div>
                <div class="d-flex justify-content-between align-items-center m-0">
                    <span class="badge rounded-pill bg-transparent border border-${gbs(balance).color} text-${gbs(balance).color}">${gbs(balance).text}</span>
                    <a href="#details-${contact.id}" data-bs-toggle="collapse" role="button" aria-expanded="false" class="text-muted">
                        <i class="las la-angle-down fs-4"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>`;
}

function populateCardDetails(cardElement, balanceData, error=false) {
    const detailsArea = cardElement.querySelector(`#details-${balanceData.id}`);
    if (error) {
        detailsArea.innerHTML = `
            <div class="text-danger text-center p-2 mt-2 mb-2 border-bottom border-top">
                <p>خطا در خواندن اطلاعات</p>
                <button id ="acc-detail-reload-${balanceData.id}" type="button" class="btn rounded-pill bg-transparent border-danger btn-danger text-danger">
                    <i class="las la-redo-alt ms-1"></i>دوباره 
                </button>
            </div>`;
        cardElement.querySelector(`#acc-detail-reload-${balanceData.id}`).addEventListener('click', () => {
            cardElement.querySelector('.collapse').dispatchEvent(new Event('show.bs.collapse'));
        });
    } else {
        detailsArea.innerHTML = `
            <div class="mt-2 mb-2 border-top border-bottom pt-2 pb-2">
                <div class="row align-items-center mb-2">
                    <div class="col-5 text-end"><span class="text-muted">مجموع بدهکاری</span></div>
                    <div class="col-4 text-center"><span class="fw-bold">${formatCurrency(balanceData.total_debit)}</span></div>
                    <div class="col-3 text-start"><span class="badge bg-soft-${gbs(balanceData.total_debit).color} text-${gbs(balanceData.total_debit).color}">${gbs(balanceData.total_debit).text}</span></div>
                </div>
                <div class="row align-items-center mb-2">
                    <div class="col-5 text-end"><span class="text-muted">مجموع بستانکاری</span></div>
                    <div class="col-4 text-center"><span class="fw-bold">${formatCurrency(-balanceData.total_credit)}</span></div>
                    <div class="col-3 text-start"><span class="badge bg-soft-${gbs(-balanceData.total_credit).color} text-${gbs(-balanceData.total_credit).color}">${gbs(-balanceData.total_credit).text}</span></div>
                </div>
                <div class="row align-items-center mb-2">
                    <div class="col-5 text-end"><span class="text-muted">مانده حساب کل</span></div>
                    <div class="col-4 text-center"><span class="fw-bold">${formatCurrency(balanceData.total_balance)}</span></div>
                    <div class="col-3 text-start"><span class="badge bg-soft-${gbs(balanceData.total_balance).color} text-${gbs(balanceData.total_balance).color}">${gbs(balanceData.total_balance).text}</span></div>
                </div>
                <div class="row align-items-center mb-2">
                    <div class="col-5 text-end"><span class="text-muted">مانده حساب امروز</span></div>
                    <div class="col-4 text-center"><span class="fw-bold">${formatCurrency(balanceData.today_balance)}</span></div>
                    <div class="col-3 text-start"><span class="badge bg-soft-${gbs(balanceData.today_balance).color} text-${gbs(balanceData.today_balance).color}">${gbs(balanceData.today_balance).text}</span></div>
                </div>
                <div class="row align-items-center">
                    <div class="col-5 text-end"><span class="text-muted">حساب سررسید نشده</span></div>
                    <div class="col-4 text-center"><span class="fw-bold">${formatCurrency(balanceData.not_due_debit)}</span></div>
                    <div class="col-3 text-start"><span class="badge bg-soft-${gbs(balanceData.not_due_debit).color} text-${gbs(balanceData.not_due_debit).color}">${gbs(balanceData.not_due_debit).text}</span></div>
                </div>
            </div>
        `;
    }
}

function generateCardDetails(allContacts) {
    allContacts.forEach(contact => {
        const cardElement = document.getElementById(`contact-card-${contact.id}`);
        if (!cardElement) return;
        const detailsElement = cardElement.querySelector('.collapse');
        if (detailsElement) {
            detailsElement.addEventListener('show.bs.collapse', async () => {
                if (cardElement.dataset.loaded) return;
                const detailsContainer = cardElement.querySelector(`#details-${contact.id}`);
                if (detailsContainer) {
                    detailsContainer.innerHTML = generateDetailsSkeletonHtml();
                }
                try {
                    const balanceData = await api.accountingGetContactBalance(contact.id);
                    populateCardDetails(cardElement, { ...balanceData, id: contact.id });
                    cardElement.dataset.loaded = "true";
                } catch (error) {
                    handleError(error, contactsAlertId);
                    populateCardDetails(cardElement, {id: contact.id}, true);
                }
            }, { once: false });
        }
    });
}

function populateContactCards(){
    api.accountingGetContacts().then(allContacts => {
        const groupedContacts = {customer: [], supplier: [], employee: [], partner: [], bank: [], other: []};

        if (!allContacts || allContacts.length === 0) return;

        allContacts.sort((a, b) => Math.abs(b.cached_total_balance) - Math.abs(a.cached_total_balance));
        allContacts.forEach(c => {
            if (groupedContacts[c.contact_type]) {
                groupedContacts[c.contact_type].push(c);
            }
        });

        const panels = {
            '#customers-panel': groupedContacts.customer,
            '#suppliers-panel': groupedContacts.supplier,
            '#employees-panel': groupedContacts.employee,
            '#partners-panel': groupedContacts.partner,
            '#banks-panel': groupedContacts.bank,
            '#other-panel': groupedContacts.other
        };

        for (const panelSelector in panels) {
            const container = document.querySelector(`${panelSelector} .row`);
            if (container) {
                container.innerHTML = panels[panelSelector].map(generateContactCardHtml).join('');
            }
        }

        generateCardDetails(allContacts);

    }).catch(error => {
        handleError(error, contactsAlertId);
    })
}

export async function initAccountingContactsPage() {
    populateContactCards();
}

// Settings:

async function getContactsTableData (){
    const contacts = await api.accountingGetContacts();
    return contacts.map(contact => [
        contact.name,
        translateContactType(contact.contact_type),
        toPersianDigits(contact.detail_id),
        formatCreditTerm(contact.credit_term_days),
        `<div class="d-flex justify-content-center">
            <a href="" class="btn btn-sm btn-soft-warning ms-2" data-action="edit" data-bs-toggle="modal" data-bs-target="#contact-modal" data-id="${contact.id}"><i class="las la-pen"></i></a>
            <a href="" class="btn btn-sm btn-soft-danger" data-action="delete" data-id="${contact.id}"><i class="las la-trash"></i></a>
        </div>`
    ]);
}

function persianizeDatatable() {
    const info = document.querySelector('.datatable-info');
    if (info) {
        info.innerHTML = toPersianDigits(info.innerHTML);
    }
    const select = document.querySelector('.datatable-selector');
    if (select) {
        Array.from(select.options).forEach(option => {
            option.text = toPersianDigits(option.text);
        });
    }
    const paginationLinks = document.querySelectorAll('.datatable-pagination-list-item-link');
    if (paginationLinks) {
        paginationLinks.forEach(link => {
            if (!isNaN(link.innerText)) {
                link.innerHTML = toPersianDigits(link.innerHTML);
            }
        });
    }
}

function renderContactsTable(refreshDatatable=false) {
    getContactsTableData().then(tableData => {
        if (datatable && datatable.initialized && refreshDatatable) {
            let num = datatable.data.data.length;
            datatable.insert({ data: tableData });
            datatable.rows.remove([...Array(num).keys()]);
            persianizeDatatable();
        } else {
            if (datatable) datatable.destroy();
            datatable = new DataTable("#contacts-datatable", {
                data: {
                    headings: ['نام', 'نوع', 'کد تفصیلی', 'شرایط اعتباری', '<div class="text-center">عملیات</div>'],
                    data: tableData
                },
                columns: [
                    { select: 4, sortable: false }
                ],
                searchable: true,
                perPage: 10,
                labels: {
                    placeholder: "جستجو...",
                    perPage: " مورد در هر صفحه",
                    noRows: "هیچ طرف‌حسابی یافت نشد!",
                    info: "نمایش {start} تا {end} از {rows} مورد",
                }
            });
            datatable.on('datatable.init', persianizeDatatable);
            datatable.on('datatable.update', persianizeDatatable);
            datatable.on('datatable.search', persianizeDatatable);
            datatable.on('datatable.page', persianizeDatatable);
            handleTableEvents();
        }
    }).catch(tableError => {
        handleError(tableError, settingsAlertId);
    });
}

function generateStatusOptions(selectedValue = 'include_all') {
    const options = {
        'include_all': 'شامل همه موارد',
        'include_debit': 'فقط بدهکار',
        'include_credit': 'فقط بستانکار',
        'ignore': 'نادیده بگیر'
    };
    return Object.entries(options).map(([value, text]) =>
        `<option value="${value}" ${value === selectedValue ? 'selected' : ''}>${text}</option>`
    ).join('');
}

function PopulateLedgers(state, ledgers=null, ledgerRules = []) {
    const ledgerRulesContainer = document.getElementById('ledger-rules-container');
    if (state === 'empty'){
        ledgerRulesContainer.innerHTML = '';
    } else if (state === 'loading'){
        ledgerRulesContainer.innerHTML = '<div class="text-center"><div class="spinner-border spinner-border-sm" role="status"></div><span class="me-2">در حال بارگذاری معین‌ها...</span></div>';
    } else if (state === 'notFound'){
        ledgerRulesContainer.innerHTML = '<p class="text-muted text-center">هیچ معین مرتبطی برای این تفصیلی یافت نشد.</p>';
    } else if (state === 'error'){
        ledgerRulesContainer.innerHTML = '<p class="text-danger text-center">خطا در بارگذاری معین‌ها.</p>';
    } else if (state === 'data' && ledgers){
        ledgerRulesContainer.innerHTML = `
            <table class="table table-sm">
                <tbody>
                    ${ledgers.map(ledger => {
            const currentRule = ledgerRules.find(rule => rule.ledger_id === ledger.Id);
            const selectedStatus = currentRule ? currentRule.status : 'include_all';
            return `
                                <tr data-ledger-id="${ledger.Id}">
                                    <td>${toPersianDigits(ledger.Code)} - ${ledger.Title}</td>
                                    <td style="width: 200px;">
                                        <select class="form-select form-select-sm ledger-rule-status">
                                            ${generateStatusOptions(selectedStatus)}
                                        </select>
                                    </td>
                                </tr>
                                `;
        }).join('')}
                </tbody>
            </table>
        `;
    }
}

function loadLedgers(detailId, ledgerRules = []){
    if (!detailId) {
        PopulateLedgers('empty');
        return;
    }
    PopulateLedgers('loading');
    api.accountingGetLedgers(detailId).then(ledgers => {
        if (ledgers.length === 0) {
            PopulateLedgers('notFound');
            return;
        }
        if (ledgerRules.length > 0){
            PopulateLedgers('data', ledgers, ledgerRules);
        } else {
            PopulateLedgers('data', ledgers);
        }
    }).catch(error => {
        handleError(error, settingsAlertId);
        PopulateLedgers('error');
    });
}

function updateDetailsSelectrData(defaultValue=null){
    api.accountingGetDetails().then(details => {
        const options = details.map(detail => ({
            value: detail.Id.toString(),
            text: toPersianDigits(`${detail.Code} - ${detail.Title}`),
            disabled: detail.isContact,
        }));

        if (defaultValue) {
            const selectedOption = options.find(opt => opt.value === defaultValue.toString());
            if (selectedOption) {
                selectedOption.disabled = false;
            }
        }

        detailCodeSelectr.removeAll();

        if (defaultValue) {
            detailCodeSelectr.add(options);
            detailCodeSelectr.setValue(defaultValue.toString());
            detailCodeSelectr.disable();
            isResettingForm = false;
        } else {
            isResettingForm = false;
            detailCodeSelectr.add(options);
            detailCodeSelectr.enable();
        }
    }).catch(error => {
        handleError(error, settingsAlertId);
    });
}

function openModalForEdit(contactId) {
    resetModalForm();
    const modalLabel = document.getElementById('contactModalLabel').parentElement;
    const submitButton = document.querySelector('#contact-modal button[type="submit"]');
    modalLabel.firstElementChild.textContent = 'ویرایش طرف‌حساب';
    modalLabel.classList.remove('bg-primary');
    modalLabel.classList.add('bg-warning');
    submitButton.textContent = 'ذخیره تغییرات';
    submitButton.classList.remove('btn-primary');
    submitButton.classList.add('btn-warning');

    document.getElementById('contact-id').value = contactId;

    api.accountingGetContactId(contactId).then(contact => {
        document.getElementById('contact-name').value = contact.name;
        document.getElementById('contact-type').value = contact.contact_type;
        document.getElementById('credit-term-days').value = contact.credit_term_days;

        isResettingForm = true;
        updateDetailsSelectrData(contact.detail_id.toString());
        loadLedgers(contact.detail_id, contact.ledger_rules);

    }).catch(error => {
        handleError(error, settingsAlertId);
        resetModalForm();
    });
}

function handleTableEvents() {
    const table = document.getElementById('contacts-datatable');
    if (!table) return;

    table.addEventListener('click', (event) => {
        event.preventDefault();
        const target = event.target.closest('a[data-action]');
        if (!target) return;

        const action = target.dataset.action;
        const id = target.dataset.id;

        if (action === 'edit') {
            openModalForEdit(id);
        }

        if (action === 'delete') {
            api.accountingDeleteContact(id)
                .then(() => {
                    showAlert(settingsAlertId, 'success', 'موفق!', 'طرف‌حساب با موفقیت حذف شد.');
                    renderContactsTable(true);
                })
                .catch(err => handleError(err, settingsAlertId));
        }
    });
}

function resetModalForm() {
    const ledgerRulesContainer = document.getElementById('ledger-rules-container');
    const submitButton = document.querySelector('#contact-modal button[type="submit"]');
    const modalLabel = document.getElementById('contactModalLabel').parentElement;
    isResettingForm = true;

    document.getElementById('contact-id').value = '';
    document.getElementById('contact-name').value = '';
    document.getElementById('contact-type').value = 'customer';
    document.getElementById('credit-term-days').value = '0';
    document.getElementById('ledger-rules-container').innerHTML = '';

    if (detailCodeSelectr) {
        detailCodeSelectr.removeAll();
    }
    if (ledgerRulesContainer) {
        ledgerRulesContainer.innerHTML = '';
    }
    if (submitButton && modalLabel) {
        modalLabel.firstElementChild.textContent = 'افزودن طرف‌حساب';
        modalLabel.classList.remove('bg-warning');
        modalLabel.classList.add('bg-primary');
        submitButton.textContent = 'افزودن';
        submitButton.classList.remove('btn-warning');
        submitButton.classList.add('btn-primary');
    }
}

function detailsSelectorEventHandler(option) {
    if (option === null || isResettingForm) return;
    const detailCode = option.value;
    document.getElementById('contact-name').value = option.text.split(' - ')[1];
    loadLedgers(detailCode);
}

function createDetailsSelector() {
    const selectEl = document.getElementById('hoofer-detail-code');
    detailCodeSelectr = new Selectr(selectEl, {
        searchable: true,
        placeholder: 'جستجو و انتخاب تفصیلی...',
        data: [],
    });
    detailCodeSelectr.on('selectr.select', option => detailsSelectorEventHandler(option));
}

function addNewContactHandler(){
    const contactModalEl = document.getElementById('contact-modal');
    const modalInstance = Modal.getInstance(contactModalEl);
    const nameInput = document.getElementById('contact-name');
    const typeInput = document.getElementById('contact-type');
    const creditInput = document.getElementById('credit-term-days');
    const submitButton = contactModalEl.querySelector('button[type="submit"]');
    const ledgerRulesContainer = document.getElementById('ledger-rules-container');
    submitButton.disabled = true;

    try {
        const ledgerRules = [];
        const ruleRows = ledgerRulesContainer.querySelectorAll('tr');
        ruleRows.forEach(row => {
            ledgerRules.push({
                ledger_id: parseInt(row.dataset.ledgerId),
                status: row.querySelector('.ledger-rule-status').value,
            });
        });

        const contactData = {
            name: nameInput.value,
            contact_type: typeInput.value,
            detail_id: detailCodeSelectr.getValue(),
            credit_term_days: parseInt(creditInput.value),
            ledger_rules: ledgerRules,
        };

        const contactId = document.getElementById('contact-id').value;

        if (contactId) {
            api.accountingPutContact(contactId, contactData).then(() => {
                showAlert(settingsAlertId, 'success', 'حله!', 'طرف‌حساب با موفقیت ویرایش شد.');
                renderContactsTable(true);
                if (modalInstance) modalInstance.hide();
                submitButton.disabled = false;
            }).catch(error => {
                handleError(error, settingsAlertId);
                submitButton.disabled = false;
            });
        } else {
            api.accountingPostContact(contactData).then(() => {
                showAlert(settingsAlertId, 'success', 'حله!', 'طرف‌حساب جدید با موفقیت ثبت شد.');
                renderContactsTable(true);
                if (modalInstance) modalInstance.hide();
                submitButton.disabled = false;
            }).catch(error => {
                handleError(error, settingsAlertId);
                submitButton.disabled = false;
            });
        }

    } catch (error) {
        handleError(error, settingsAlertId);
    } finally {
        submitButton.disabled = false;
    }
}

function initContactModal() {
    const contactModalEl = document.getElementById('contact-modal');
    const form = document.getElementById('contact-form');

    createDetailsSelector();
    form.addEventListener('submit', event => {
        event.preventDefault();
        addNewContactHandler();
    });

    contactModalEl.addEventListener('show.bs.modal', () => {
        // updateDetailsSelectrData();
    });

    contactModalEl.addEventListener('hidden.bs.modal', () => {
        resetModalForm();
    });

    document.querySelector('button[data-bs-target="#contact-modal"]').addEventListener('click', () => {
        updateDetailsSelectrData();
    });
}

export function initAccountingSettingsPage() {
    document.getElementById('modal-container').innerHTML = modalHtml;
    renderContactsTable(false);
    initContactModal();
}
